module.exports = __webpack_public_path__ + "static/media/creative-logo1(2).f47430f8.png";